// import jQuery from 'CommonScripts/jquery-1.10.2';
(function (window, document, $) {

    $(document).ready(function () {
        var $root = document.querySelectorAll('section.faq-api-search');
        if ($root.length > 0) {
             /* Functionality for the FAQ */
        //$.components.registerComponent('section.faq-api-search', function ($root) {
            $root = $($root);

            var FAQ = {
                dom: {
                    root: $root,
                    results: $root.find('.search-results'),
                    cats: $root.find('.search-categories'),
                    search: $root.prev(),
                    suggest: $root.prev().find('.faq-search-suggest')
                },
                set: {
                    url: {
                        content: '/services/Marketing/FaqApi.asmx/Content',
                        tree: '/services/Marketing/FaqApi.asmx/Tree',
                        search: '/services/Marketing/FaqApi.asmx/Search',
                        suggest: '/services/Marketing/FaqApi.asmx/Suggest',
                    },
                    query: "",
                    itemId: document.getElementById('faq-search-item-id').value,
                    returnLabel: document.getElementById('faq-search-return-label').value,
                    activeClass: 'active',
                    loading: false
                },
                fn: {
                    search: function () {
                        $fn.loadingContent(true, $dom.results);

                        /* Ajax call to get top 10 results */
                        $.ajax({
                            type: "POST",
                            url: $set.url.search,
                            data: "{query:'" + $set.query + "',itemId:'" + $set.itemId + "',filter:''}",
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            success: function (data) {
                                var obj = $.parseJSON(data.d),
                                    cats = new Array();

                                $.each(obj.data.result, function (index, value) {
                                    cats.push('<li data-path_level1="' + value.path_ids[0] + '" data-path_level2="' + value.path_ids[1] + '" data-path_level3="' + value.path_ids[2] + '"><div class="question">' + value.title + '</div><div class="answer">' + value.content + '</div></li>');
                                });
                                $dom.results.find('.article-wrapper').html('<ul>' + cats.join('') + '</ul>');

                                $fn.loadingContent(false, $dom.results);
                            },
                            error: function (a, b, c) {
                            }
                        });
                    },
                    getCats: function () {
                        $fn.loadingContent(true, $dom.cats);

                        /* Ajax call to get content tree */
                        $.ajax({
                            type: "POST",
                            url: $set.url.tree,
                            data: "{itemId:'" + $set.itemId + "'}",
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            //success: function(response1){
                            //    var obj = $.parseJSON(response1.d);
                            //    var cats = new Array();

                            //    $.each(obj.children, function (index, value) {
                            //        cats.push('<li>' + value.title + '</li>');
                            //    });
                            //    $dom.cats.find('.article-wrapper').html('<ul>' + cats.join('') + '</ul>');
                            //},
                            success: function (data) {
                                var obj = $.parseJSON(data.d),
                                    catsLevel1 = new Array(),
                                    catsLevel2 = new Array(),
                                    catsLevel3 = new Array();

                                //                                catsLevel1.push('<ul>');

                                /* Loop through the first level of categories, add them to level 1 array */
                                $.each(obj.children, function (index1, level1) {
                                    var id = (!level1.children.length) ? ' data-payload="' + level1.id + '"' : '';

                                    //                                    catsLevel1.push('<li><div class="question" '+ id +'>' + level1.title + '</div>');

                                    /* Loop through the second level of categories, add them to level 2 array
                                     * Check if category has children
                                     * First add an open <ul>, finish with a close </ul> after loop
                                      */
                                    if (!level1.children.length) { return; }


                                    catsLevel2 = new Array();
                                    catsLevel2.push('<ul>');
                                    $.each(level1.children, function (index2, level2) {
                                        var id = (!level2.children.length) ? ' data-payload="' + level2.id + '"' : '';

                                        catsLevel2.push('<li data-path_id="' + level2.id + '"><div class="question" ' + id + '>' + level2.title + '</div>');

                                        /* Loop through the third level of categories, add them to level 3 array
                                         * Check if category has children
                                          */
                                        if (!level2.children.length) { return; }
                                        catsLevel3 = new Array();

                                        catsLevel3.push('<ul>');
                                        $.each(level2.children, function (index3, level3) {
                                            var id = (!level3.children.length) ? ' data-payload="' + level3.id + '"' : '';

                                            catsLevel3.push('<li data-path_id="' + level3.id + '"><div class="question" ' + id + '>' + level3.title + '</div>');

                                        });

                                        catsLevel3.push('</ul>');
                                        catsLevel2.push(catsLevel3.join(''));

                                        catsLevel2.push('</li>');
                                    });

                                    catsLevel2.push('</ul>');
                                    catsLevel1.push(catsLevel2.join(''));

                                    catsLevel1.push('</li>');
                                });

                                //                                catsLevel1.push('</ul>');

                                $dom.cats.find('.article-wrapper').html(catsLevel1.join(''));

                                $fn.loadingContent(false, $dom.cats);
                            },
                            error: function (a, b, c) {
                            }
                        });
                    },
                    getSuggestion: function () {
                        /* Do not make AJAX calls until 3 characters are entere */
                        if ($set.query.length <= 2) {
                            return;
                        }

                        /* Ajax call to get top 10 results */
                        $.ajax({
                            type: "POST",
                            url: $set.url.suggest,
                            data: "{query:'" + $set.query + "',itemId:'" + $set.itemId + "',filter:''}",
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            success: function (data) {
                                var obj = $.parseJSON(data.d),
                                    cats = new Array(),
                                    search, splitAt, result;

                                /* Search through results and display them in suggestion box */
                                $.each(obj.result, function (index, value) {
                                    search = value.name;
                                    /* Find at which char the search query is found, to split later */
                                    splitAt = search.toLowerCase().indexOf($set.query);

                                    /* If search query is found in the name, make the query bold
                                     * Otherwise display the name normally
                                      */
                                    result = (splitAt !== -1) ? search.slice(0, splitAt) + '<b>' + $set.query + '</b>' + search.slice(splitAt + $set.query.length, value.length) : value.name;
                                    cats.push('<li><div class="question" data-payload="' + value.payload + '">' + result + '</div></li>');
                                });
                                $dom.suggest.html('<ul>' + cats.join('') + '</ul>');

                                $fn.showSuggestionBox();
                            },
                            error: function (a, b, c) {
                            }
                        });
                    },
                    getContent: function (payload, cat) {

                        $fn.loadingContent(true, $dom.results);

                        /* Build the data element depending on whether it's a suggest element or tree node element */
                        var data = (cat === 'treenode') ? "{filter:'[{\"property\":\"path_ids\",\"value\":\"" + payload + "\"}]&fields=title',query:'',itemId:'" + $set.itemId + "'}" : "{id:" + payload + ",itemId:'" + $set.itemId + "'}";

                        /* Ajax call to get top 10 results */
                        $.ajax({
                            type: "POST",
                            url: (cat === 'treenode') ? $set.url.search : $set.url.content,
                            data: data,
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            success: function (data) {
                                var result = $.parseJSON(data.d),
                                    cats = new Array();

                                if (cat === 'treenode') {
                                    obj = (result.data.result.length > 1) ? result.data.result : result.data.result[0];
                                } else {
                                    obj = result.data;
                                }

                                if (obj.length) {
                                    $.each(obj, function (index, value) {
                                        cats.push('<li data-path_level1="' + value.path_ids[0] + '" data-path_level2="' + value.path_ids[1] + '" data-path_level3="' + value.path_ids[2] + '"><div class="question">' + value.title + '</div><div class="answer">' + value.content + '</div></li>');
                                    });
                                    $dom.results.find('.article-wrapper').html('<ul>' + cats.join('') + '</ul>');
                                } else {
                                    $dom.results.find('.article-wrapper').html('<div style="margin-bottom: 2em;" class="clearfix back"><div class="button left blue"><a href="#">' + $set.returnLabel + '<i class="velux-icon icon-chevron-left-white"></i></a></div></div><div class="content-wrapper"><h3>' + obj.title + '</h3><div class="content">' + obj.raw_content + '</div></div>');
                                }
                                $fn.loadingContent(false, $dom.results);
                            },
                            error: function (a, b, c) {
                            }
                        });

                    },
                    showSuggestionBox: function () {
                        /* Only show the suggestion box when:
                         * 1. It is not active yet
                         * 2. A value is in the input field
                          */
                        if (!$dom.suggest.hasClass($set.activeClass) && $set.query) {
                            //$dom.suggest.show().addClass($set.activeClass);
                            $dom.suggest.addClass($set.activeClass);
                        }
                    },
                    hideSuggestionBox: function () {
                        $dom.suggest.removeClass($set.activeClass);
                    },
                    loadingContent: function (state, element) {
                        /* Set the parent element
                         * If element is sent, use this
                         * As default, use the root element
                          */
                        var parent = (element) ? element : $root;
                        $set.loading = state;

                        if (state) {
                            parent.addClass('loading');
                        } else {
                            parent.removeClass('loading');
                        }
                    }
                },
                vm: {
                    cats: null
                }
            },

            /* Add quick access variables to be used in local function
                * Keep main variable name in case it needs to be shared with other JS files
                */
            $dom = FAQ.dom,
            $set = FAQ.set,
            $fn = FAQ.fn,
            $vm = FAQ.vm;

            $fn.search();
            $fn.getCats();


            /* Triggers for the Search Bar
             * Clicking on search button, or pressing enter will search
              */
            $dom.search.on({
                click: function (e) {
                    $set.query = $dom.search.find('input').val();

                    $fn.hideSuggestionBox();
                    $fn.search();

                    $dom.results.insertBefore($dom.cats);

                    e.preventDefault();
                    return false;
                }
            }, 'a');

            /* Auto-completely is enabled by default and works every time a character is entered */
            $dom.search.on({
                /* Call suggestion service on each key up */
                keyup: function (e) {
                    $set.query = $(e.target).val();

                    $fn.getSuggestion();
                },
                /* On blur, hide the suggestion box */
                //blur: $fn.hideSuggestionBox,
                /* On click, show the suggestion box */
                focus: $fn.showSuggestionBox
            }, 'input');

            /* Clear the search results when clearing search query */
            $dom.search.on({
                click: function (e) {
                    $set.query = '';
                    $fn.search();

                    $fn.hideSuggestionBox();
                }
            }, '.icon-cross');

            /* Triggers for the Search Results */
            $dom.results.on({
                click: function (e) {
                    var active = $(e.target).closest('li').hasClass($set.activeClass) ? true : false,
                        question = $(e.target).closest('li'),
                        levels = [question.data('path_level1'), question.data('path_level2'), question.data('path_level3')];

                    /* Remove all focus classes on categories */
                    $dom.cats.find('li').removeClass('focus').find('ul').hide();

                    /* Set focus classes on categories that are related */
                    for (var i = 0; i < levels.length; i++) {
                        $dom.cats.find('li[data-path_id="' + levels[i] + '"]').addClass('focus').find('> ul').show();
                    };

                    /* Remove all active classes from FAQ items */
                    $dom.results.find('li').removeClass($set.activeClass);

                    /* Only when not clicking the current active FAQ item, open the new one */
                    if (!active) {
                        /* Set the current FAQ item to active */
                        $(e.target).closest('li').addClass($set.activeClass);
                    }

                }
            }, '.question');
            $dom.results.on({
                click: function (e) {
                    e.preventDefault();
                    $set.query = '';
                    $fn.search();

                    $dom.cats.find('li').removeClass('focus');
                }
            }, '.back');

            /* Triggers for Search Suggestions */
            $dom.suggest.on({
                click: function (e) {
                    $fn.getContent("'" + $(e.target).closest('li').find('.question').data('payload') + "'");
                    $fn.hideSuggestionBox();

                    $dom.results.insertBefore($dom.cats);
                }
            }, '.question');


            /* Triggers for Categories (items and tree) */
            $dom.cats.on({
                click: function (e) {
                    /* Always close the other categories of the same level when opening a new one */
                    $(e.target).closest('li').siblings().find('ul').hide();

                    $(e.target).next().toggle(0, function () {
                        /* Open a category of close if when it is already open */
                        if ($(this).css('display') == 'none') {
                            $(this).find('ul').hide();
                        }
                    });
                }
            }, '.question:not([data-payload])');

            $dom.cats.on({
                click: function (e) {
                    $fn.getContent($(e.target).data('payload'), 'treenode');

                    /* Hide all the focus elements */
                    $dom.cats.find('li').removeClass('focus');

                    var question = $(e.target);
                    question.parents('li').addClass('focus');
                }
            }, '.question[data-payload]');
        //});

        }
       
    });

})(window, document, jQuery);